// ANGULAR DEPENDENCY
import { Component, OnDestroy, OnInit } from '@angular/core';

// EXTERNAL MODULES
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

// SERVICES
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalStoreService } from '../../../../state/global/global-store.service';

// COMPONENTS
import { NotificationComponent } from '../../../../modules/shared/components/modals/notification/notification.component';

// INTERFACE AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';
import { PopupNotification } from '../../../../models/global/popup/popup-notification.interface';

// BASE CLASS
import { ModalBaseClass } from '../../../../modules/shared/components/modals/base_class/modal-base-class';

/**
 * This component is used for global popup notification
 * For global popup notification purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) popup notification component created
 */
@Component({
  standalone: false,
  selector: 'kt-popup-notification',
  templateUrl: './popup-notification.component.html',
  styleUrls: [],
})
export class PopupNotificationComponent extends ModalBaseClass implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  options: PopupNotification;

  constructor(
    public modalService: NgbModal,
    public globalService: GlobalStoreService,
    public translate: TranslateService,
    private toastr: ToastrService) {
    super(modalService);
  }

  /**
   * Lifecycle hook called after the constructor
   */
  ngOnInit() {
    this.subscriptions.push(
      this.globalService.selectPopupNotification().subscribe(data => {
        if (data) {
          // toastr open for normal alerts
          if (data.type && (
            data.type === ModalType.ALERT ||
            data.type === ModalType.INFO ||
            data.type === ModalType.ERROR ||
            data.type === ModalType.SUCCESS
          )) {
            this.displayToastrMessage(data);
          } else {
            // OPEN NOTIFICATION POPUP
            this.options = data;
            const modalRef = this.openPopUp(NotificationComponent, { options: this.options });
            modalRef.result.then(result => {
              if (result) {
                // OPTIONS CALLBACK
                if (this.options.callback) {
                  this.options.callback({ ...data, success: data.type === ModalType.SUCCESS });
                }
                this.globalService.dispatchPopupNotificationCallback(result);
              }
            });
          }
        }
      }),
    );
  }

  /**
   * Display toastr message
   */
  displayToastrMessage(options: PopupNotification) {
    const message = options.message ? this.translate.instant(options.message) : '';
	const title = options.title ? this.translate.instant(options.title) : '';
    switch (options.type) {
      case ModalType.SUCCESS:
        this.toastr.success(message, title, { closeButton: true, timeOut: 3000 });
        break;
      case ModalType.ERROR:
        this.toastr.error(message, title, { closeButton: true, timeOut: 3000 });;
        break;
      case ModalType.INFO:
        this.toastr.info(message, title, { closeButton: true, timeOut: 3000 });;
        break;
      case ModalType.ALERT:
        this.toastr.warning(message, title, { closeButton: true, timeOut: 3000 });;
        break;
      default:
        this.toastr.info(message, title, { closeButton: true, timeOut: 3000 });;
    }

    if (options.callback) {
      options.callback({ ...options, success: options.type === ModalType.SUCCESS });
    }
  }

  /**
   * Destroy all subscriptions
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub && sub.unsubscribe());
  }

}

